import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@app/modules/shared/shared.module";
import { RoleListComponent } from "./role/components/role-list/role-list.component";
import { RoleFormComponent } from "./role/components/role-form/role-form.component";
import { UserListComponent } from "./user/components/user-list/user-list.component";
import { UserFormComponent } from "./user/components/user-form/user-form.component";
import { SectorFormComponent } from "@dashboard/modules/management/sector/components/sector-form/sector-form.component";
import { SectorListComponent } from "@dashboard/modules/management/sector/components/sector-list/sector-list.component";
import { EmailSettingsComponent } from "@dashboard/modules/management/email/components/email-settings/email-settings.component";
import { InstallationUserListComponent } from "./installation-user/components/installation-user-list/installation-user-list.component";
import { InstallationUserFormComponent } from "./installation-user/components/installation-user-form/installation-user-form.component";
import { RolePermissionComponent } from "./role/components/role-permission/role-permission.component";

@NgModule({
  imports: [CommonModule, SharedModule.forRoot()],
  declarations: [
    RoleListComponent,
    RoleFormComponent,
    UserListComponent,
    UserFormComponent,
    SectorFormComponent,
    SectorListComponent,
    EmailSettingsComponent,
    InstallationUserListComponent,
    InstallationUserFormComponent,
    RolePermissionComponent,
  ],
  exports: [
    RoleListComponent,
    RoleFormComponent,
    UserListComponent,
    UserFormComponent,
    SectorListComponent,
    SectorFormComponent,
    EmailSettingsComponent,
    InstallationUserListComponent,
    InstallationUserFormComponent,
    RolePermissionComponent,
  ],
  providers: [],
})
export class ManagementModule {}
